// Generated by ReScript, PLEASE EDIT WITH CARE


function getFareSelectedCardEventValue(rollout_group) {
  if (rollout_group) {
    return "0";
  } else {
    return "1";
  }
}

var FareSelectedCard = {
  getFareSelectedCardEventValue: getFareSelectedCardEventValue
};

export {
  FareSelectedCard ,
}
/* No side effect */
